<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'educacaoInclusiva.planosAEE' })"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano de Atendimento Educacional Especializado
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn depressed color="primary" @click="imprimirPlano">
          Imprimir plano
          <v-icon small right> mdi-note </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="plano">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <label>Aluno(a)</label>
                <v-input>{{ plano.matricula?.aluno?.nomecompleto || "- - -" }}</v-input>
              </v-col>
              <v-col cols="12" md="6">
                <label>Professor(a) do AEE</label>
                <v-input>{{ professoresDoAEE }}</v-input>
              </v-col>
              <v-col cols="12" md="4">
                <label>Turma</label>
                <v-input>{{ plano.matricula?.turma?.descricao || "- - -" }}</v-input>
              </v-col>
              <v-col cols="12" md="4">
                <label>Turno</label>
                <v-input>{{ plano.matricula?.turma?.turno?.descricao || "- - -" }}</v-input>
              </v-col>
              <v-col cols="12" md="4">
                <label>Professor(a) auxiliar</label>
                <v-input>{{ professoresAuxiliaresDescricao }}</v-input>
              </v-col>
              <v-col cols="12" md="4">
                <label>Bimestre</label>
                <v-input>
                  <v-chip>{{ descricaoDoBimestre }}</v-chip>
                </v-input>
              </v-col>
              <v-col cols="12" md="4">
                <label>Data</label>
                <v-input>
                  <v-chip>{{ formatarData(plano.data) }}</v-chip>
                </v-input>
              </v-col>
              <v-col cols="12" md="4">
                <label>Status</label>
                <e-situacao-plano
                  :plano="plano"
                  servico="planosBimestraisAEEService"
                  @update="carregarPlano"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <e-titulo-secao-aee titulo="Identificação" />
            <e-campo-visualizacao-aee
              rotulo="Deficiência / TEA / Altas habilidades ou superdotação"
              :lista="plano.deficiencias"
              :complemento="plano.deficiencia_outra"
              complemento-rotulo="Outra"
            />

            <e-titulo-secao-aee titulo="Estudo do caso" />
            <e-campo-visualizacao-aee
              rotulo="1. Mapeamento de barreiras"
              :texto="plano.mapeamento_barreiras"
            />
            <e-campo-visualizacao-aee
              rotulo="2. Potencialidades e interesses"
              :texto="plano.potencialidades_interesses"
            />
            <e-campo-visualizacao-aee
              rotulo="3. Descrição da demanda"
              :texto="plano.descricao_demanda"
            />

            <e-titulo-secao-aee titulo="4. Plano de suporte e acessibilidade" />
            <e-campo-visualizacao-aee
              rotulo="Profissional de Apoio Escolar"
              :texto="plano.profissional_apoio_escolar"
            />
            <e-campo-visualizacao-aee
              rotulo="Momentos do profissional de apoio"
              :texto="plano.profissional_apoio_momentos"
            />
            <e-campo-visualizacao-aee
              rotulo="Adaptação de Materiais"
              :lista="plano.adaptacao_materiais"
            />
            <e-campo-visualizacao-aee
              rotulo="Flexibilização Ambiental"
              :lista="plano.flexibilizacao_ambiental"
            />

            <e-titulo-secao-aee titulo="Organização do Atendimento Educacional Especializado" />
            <e-campo-visualizacao-aee
              rotulo="Frequência do Atendimento semanal"
              :texto="descricaoDaFrequencia"
            />
            <e-campo-visualizacao-aee
              rotulo="Composição do atendimento"
              :texto="plano.composicao_atendimento"
            />
            <e-campo-visualizacao-aee rotulo="Dias e Horários do AEE" :lista="diasEHorarios" />
            <e-campo-visualizacao-aee
              rotulo="Tipo de Atendimento"
              :lista="plano.tipos_de_atendimento"
            />

            <e-titulo-secao-aee titulo="Plano de desenvolvimento individualizado" />
            <e-campo-visualizacao-aee
              rotulo="Área"
              :lista="plano.areas"
              :complemento="plano.areas_outras"
              complemento-rotulo="Outras"
            />
            <e-campo-visualizacao-aee rotulo="Objetivos" :texto="plano.objetivos" />
            <e-campo-visualizacao-aee rotulo="Metodologia" :texto="plano.metodologia" />
            <e-campo-visualizacao-aee rotulo="Recursos" :texto="plano.recursos" />

            <e-titulo-secao-aee titulo="Acompanhamento e Avaliação" />
            <e-campo-visualizacao-aee :texto="plano.acompanhamento_avaliacao" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import ETituloSecaoAEE from "@/components/EducacaoInclusiva/ETituloSecaoAEE.vue";
import ECampoVisualizacaoAEE from "@/components/EducacaoInclusiva/ECampoVisualizacaoAEE.vue";

export default {
  components: {
    "e-titulo-secao-aee": ETituloSecaoAEE,
    "e-campo-visualizacao-aee": ECampoVisualizacaoAEE,
  },
  data() {
    return {
      plano: null,
      horarios: {},
      professoresAuxiliares: [],
    };
  },
  computed: {
    planoId() {
      return parseInt(this.$route.params.id, 10);
    },
    professoresDoAEE() {
      const nomes = [
        this.plano?.gestao_de_aula_a_e_e?.professor?.nome,
        ...(this.plano?.matricula?.turma?.gestao_de_aulas_a_e_e ?? []).map(
          (gestao) => gestao?.professor?.nome
        ),
      ].filter(Boolean);
      return nomes.length ? [...new Set(nomes)].join(", ") : "- - -";
    },
    professoresAuxiliaresDescricao() {
      if (!this.professoresAuxiliares.length) return "Sem professor auxiliar vinculado";
      return this.professoresAuxiliares.map((professor) => professor.nome).join(", ");
    },
    descricaoDoBimestre() {
      const item = this.$constants.bimestres.find((b) => b.value === this.plano?.bimestre);
      return item ? item.desc : "- - -";
    },
    descricaoDaFrequencia() {
      const item = this.$constants.frequenciaSemanalAEE.find(
        (f) => f.value === this.plano?.frequencia_semanal
      );
      return item ? item.desc : null;
    },
    diasEHorarios() {
      return (this.plano?.dias_horarios ?? []).map(
        (item) => `${item.dia} — ${this.horarios[item.horario_id] || "horário não informado"}`
      );
    },
  },
  async mounted() {
    await this.carregarPlano();
  },
  methods: {
    async carregarPlano() {
      this.$loaderService.open("Carregando plano...");
      try {
        const payload = await this.$services.planosBimestraisAEEService.show(this.planoId);
        this.plano = payload.plano;
        this.horarios = payload.horarios || {};
        this.professoresAuxiliares = payload.professoresAuxiliares || [];
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    formatarData(data) {
      if (!data) return "- - -";
      return data.substr(0, 10).split("-").reverse().join("/");
    },
    async imprimirPlano() {
      this.$loaderService.open("Gerando plano bimestral AEE...");
      try {
        await this.$services.planosBimestraisAEEService.pdf(
          this.plano.matricula_id,
          this.plano.bimestre
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style></style>
